export default {
  selling_price_management: ['selling_price_management'],
  selling_price_add: ['selling_price_add'],
  selling_price_edit: ['selling_price_edit'],
  selling_price_delete: ['selling_price_delete'],
  selling_price_archive: ['selling_price_archive'],
  selling_price_restore: ['selling_price_restore']
}
